<template>
  <GroupTraining />
</template>

<script>
import GroupTraining from '@/components/content/education/training/TrainerGroupTraining.vue'

export default {
  name: 'GroupTrainingPage',
  components: { GroupTraining }
}
</script>

<style scoped>

</style>
